import { useEffect } from "react";

/**
 * Sets the document title and meta description for the current page.
 * Adds canonical link if a URL is provided.
 * Restores previous values on unmount.
 */
export default function usePageMeta({ title, description, canonical }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    // meta description
    let descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl ? descEl.getAttribute("content") : null;
    if (description) {
      if (!descEl) {
        descEl = document.createElement("meta");
        descEl.setAttribute("name", "description");
        document.head.appendChild(descEl);
      }
      descEl.setAttribute("content", description);
    }

    // canonical
    let canEl = document.querySelector('link[rel="canonical"]');
    const prevCan = canEl ? canEl.getAttribute("href") : null;
    if (canonical) {
      if (!canEl) {
        canEl = document.createElement("link");
        canEl.setAttribute("rel", "canonical");
        document.head.appendChild(canEl);
      }
      canEl.setAttribute("href", canonical);
    }

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== null) descEl.setAttribute("content", prevDesc);
      if (canEl && prevCan !== null) canEl.setAttribute("href", prevCan);
    };
  }, [title, description, canonical]);
}
